/* ARGUS PR #164 (CRITICAL): single source for the Interstate `.ids-*` DIY component
   recipe layer (`.ids-btn`, `.ids-slideout*`, …). Only imported by components that
   actually render those classes (support-menu-trigger, support-menu-slideout) — see
   the dead-CSS finding this split also resolves (SupportMenuItem/Panel render none). */
@tailwind components;
